
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11043_459087)"}},[_c('path',{attrs:{"d":"M13.692 16.667A4.174 4.174 0 019.608 20a4.174 4.174 0 01-4.083-3.333h8.167z","fill":"#12ACF2"}}),_c('path',{attrs:{"d":"M16.692 5.833a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833z","fill":"#2C8DFF"}}),_c('path',{attrs:{"d":"M16.892 7.492c-.067 0-.134.008-.2.008a4.591 4.591 0 01-4.584-4.583c0-.75.184-1.467.509-2.092A6.926 6.926 0 002.575 5.433L.617 11.758C.117 13.367 1.325 15 3.008 15h13.05c1.734 0 2.942-1.725 2.35-3.35L16.9 7.492h-.008z","fill":"#176CD8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11043_459087"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    